import React, { useEffect, useState } from "react";
import { api } from "../../config";
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { Container, Label, Button, Form, ModalFooter, Modal, ModalHeader, ModalBody, CardHeader, Card, CardBody, Col, Input, Row, FormFeedback } from 'reactstrap';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModalAlterarSenha from "../../Components/Common/ModalAtualizarSenha";

import Select from "react-select";
import * as Yup from "yup";
import { useFormik } from "formik";
import { fetchComAuth } from "../../common/api";
import { method } from "lodash";

const ListaUsuarios = () => {
    document.title = "Lista de Usuários | EVOMAP - Tecnologia que conecta negócios";

    const [usuariosData, setUsuariosData] = useState([]);
    const [search, setSearch] = useState("");
    const [modal_list, setmodal_list] = useState(false);
    const [selectedMulti, setselectedMulti] = useState(null);
    const [selectedTipo, setselectedTipo] = useState(null);
    const [feirasOptions, setFeirasOptions] = useState([]);
    const [tiposOptions, setTiposOptions] = useState([]);
    const [modalFeiras, setModalFeiras] = useState(false);
    const [modalAtualizarSenha, setModalAtualizarSenha] = useState(false);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
    const [feirasSelecionadas, setFeirasSelecionadas] = useState([]);
    const [loading, setLoading] = useState(false);

    const tog_list = () => {
        if (!modal_list) {
            setselectedMulti(null);
            setselectedTipo(null);
            validation.resetForm();
        }
        setmodal_list(!modal_list);
    };

    const fecharModalFeiras = () => {
        setModalFeiras(false);
        setUsuarioSelecionado(null);
        setFeirasSelecionadas([]);
    };

    const fecharModalAtualizarSenha = () => {
        setModalAtualizarSenha(false);
        setUsuarioSelecionado(null);
    };

    const retornarTipo = (usuario) => {
        if (usuario.isEVOMAP) {
            return "EVOMAP"
        }
        
        if (usuario.isJotapix) {
            return "JOTAPIX"
        }

        if (usuario.isOrganizadora) {
            return "ORGANIZADORA"
        }
        return "COMERCIAL"

    }
    
    useEffect(() => {
        async function fetchUsuarios() {
            try {
                const response = await fetchComAuth(`${api.API_URL}/usuarios`, { method: 'GET'});
                const data = await response.json();

                setUsuariosData(data.data);
            } catch (error) {
                console.error("Erro ao buscar usuários:", error);
            }
        }

        async function fetchFeiras() {
            try {
                const response = await fetchComAuth(`${api.API_URL}/feiras`, { method: 'GET' } );
                const data = await response.json();
                const options = data.data.map(feira => ({ value: feira.id, label: feira.nome }));
                
                setFeirasOptions(options);
            } catch (error) {
                console.error("Erro ao buscar feiras:", error);
            }
        }

        async function fetchTipos() {
            try {
                const response = await fetchComAuth(`${api.API_URL}/roles`, { method: 'GET' });
                const data = await response.json();
                const options = data.map(role => ({ value: role.id, label: role.nome }));
                setTiposOptions(options);
            } catch (error) {
                console.error("Erro ao buscar tipos de usuário:", error);
            }
        }

        fetchUsuarios();
        fetchFeiras();
        fetchTipos();
    }, []);

    const filteredUsuarios = usuariosData.filter((usuario) =>
        usuario.name?.toLowerCase().includes(search.toLowerCase())
    );

    const handleMulti = (selected) => setselectedMulti(selected);
    const handleTipo = (selected) => setselectedTipo(selected);

    const abrirModalAtualizarSenha = (usuario) => {
        setUsuarioSelecionado(usuario);

        // Resetar os valores do form
        validation.setValues({
            ...validation.values,
            senha: "",
            confirmar_senha: ""
        });

        validation.setTouched({ senha: false, confirmar_senha: false });
        setModalAtualizarSenha(true);
    };


    const abrirModalFeiras = (usuario) => {
        setUsuarioSelecionado(usuario);
        setFeirasSelecionadas(usuario.feiras?.map(f => ({
            value: f.feira?.id,
            label: f.nome || f.feira?.nome || 'Sem nome'
          })) || []);
        setModalFeiras(true);
    };

    const salvarFeiras = async () => {
        setLoading(true);
        try {
            if (!usuarioSelecionado) {
                throw new Error("Nenhum usuário selecionado");
            }
            
            const response = await fetchComAuth(`${api.API_URL}/alterarUsuario`, {
                method: 'POST',
                body: JSON.stringify({ 
                    id: usuarioSelecionado.id, 
                    feiras: feirasSelecionadas?.map(f => f.value) || [] 
                }),
                headers: {
                    'Content-Type': 'application/json', // ESSE HEADER É CRUCIAL
                    'Accept': 'application/json'
                },
            });
            
            if (!response.ok) throw new Error(await response.text());
            
            toast.success("Feiras atualizadas com sucesso.");
            setModalFeiras(false);

            const refresh = await fetchComAuth(`${api.API_URL}/usuarios`, { method: 'GET'});
            const dataRefresh = await refresh.json();
            setUsuariosData(dataRefresh.data);
        } catch (e) {
            console.error("Erro ao atualizar feiras:", e);
            toast.error(`Erro ao atualizar feiras: ${e.message}`);
        } finally {
            setLoading(false);
        }
    };

    const deletarUsuario = async (id) => {
        if (!window.confirm("Deseja realmente desativar este usuário?")) return;
        
        setLoading(true);
        try {
            setmodal_list(false);
            setModalFeiras(false);
            
            const response = await fetchComAuth(`${api.API_URL}/deletarUsuario/${id}`, {
                method: 'DELETE'
            });
            
            if (!response.ok) throw new Error();
            
            toast.success("Usuário desativado com sucesso.");
            
            const refresh = await fetchComAuth(`${api.API_URL}/usuarios`, { method: 'GET'});
            const dataRefresh = await refresh.json();
            setUsuariosData(dataRefresh.data);
        } catch (e) {
            toast.error("Erro ao desativar usuário.");
        } finally {
            setLoading(false);
        }
    };

    const customStyles = {
        control: (provided) => ({
          ...provided,
          backgroundColor: '#fff',
          borderColor: '#d1d5db',
          color: '#000',
          minHeight: '38px',
        }),
        singleValue: (provided) => ({
          ...provided,
          color: '#000',
        }),
        placeholder: (provided) => ({
          ...provided,
          color: '#6b7280',
        }),
        menu: (provided) => ({
          ...provided,
          backgroundColor: '#fff',
          color: '#000',
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? '#4f46e5' : state.isFocused ? '#e0e7ff' : '#fff',
          color: state.isSelected ? '#fff' : '#000',
          cursor: 'pointer',
        }),
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            first_name: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Por favor informe o seu e-mail"),
            first_name: Yup.string().required("Por favor informe o seu nome"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const body = {
                    email: values.email,
                    first_name: values.first_name,
                    tipo: selectedTipo?.value,
                    feiras: selectedMulti?.map(item => item.value) || [],
                };

                const response = await fetchComAuth(`${api.API_URL}/register`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json', // ESSE HEADER É CRUCIAL
                        'Accept': 'application/json'
                    },
                });

                if (!response.ok) throw new Error('Erro ao registrar usuário');

                toast.success("Usuário registrado com sucesso! A senha foi enviada para o e-mail informado.");
                setmodal_list(false);

                const refresh = await fetchComAuth(`${api.API_URL}/usuarios`, { method: 'GET'});
                const dataRefresh = await refresh.json();
                setUsuariosData(dataRefresh.data);
            } catch (error) {
                console.error("Erro ao registrar usuário:", error);
                toast.error("Erro ao registrar usuário.");
            } finally {
                setLoading(false);
            }
        }
    });

    return (
        <React.Fragment>
            <ToastContainer closeButton={false} />
  
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Lista de Usuários" pageTitle="Usuários" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <Row className="g-4">
                                        <div className="col-sm-auto">
                                            <Button 
                                                color="success" 
                                                className="add-btn me-1" 
                                                onClick={tog_list} 
                                                id="create-btn"
                                                disabled={loading}
                                            >
                                                <i className="ri-add-line align-bottom me-1"></i> 
                                                {loading ? 'Carregando...' : 'Adicionar'}
                                            </Button>
                                        </div>
                                        <div className="col-sm-3 ms-auto">
                                            <div className="d-flex justify-content-sm-end gap-2">
                                                <div className="search-box ms-2 col-sm-7">
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Pesquise por nome..."
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                        disabled={loading}
                                                    />
                                                    <i className="ri-search-line search-icon"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <div className="table-responsive table-card mb-1">
                                        <table className="table align-middle table-nowrap">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Nome</th>
                                                
                                                    <th>Feiras</th>
                                                    <th>Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredUsuarios.map((usu, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="flex-grow-1 ms-3">
                                                                <h5 className="fs-15">
                                                                   
                                                                    {usu.name}
                                                              
                                                                </h5>
                                                                <p className="text-muted mb-0">
                                                                    E-mail: <span className="fw-medium">{usu.email}</span>
                                                                </p>
                                                                <p className="text-muted mb-0">
                                                                    Tipo: <span className="fw-medium">{retornarTipo(usu)}</span>
                                                                </p>
                                                            </div>
                                                                                                                
                                                        </td>
                                                    
                                                        <td>
                                                            {usu.feiras?.map((item, chave) => (
                                                                <p className="text-muted mb-0">
                                                                    {item.feira?.logoUrl == '' ? 
                                                                        <img src={item.feira?.logoUrl} alt="" className="rounded-circle avatar-xxs" /> :
                                                                        <span className="badge bg-primary-subtle text-primary">{item.feira?.nome}</span>
                                                                    }
                                                                </p>
                                                              ))}
                                                         </td>  
                                                        <td>
                                                            <div className="d-flex gap-2">
                                                                <button 
                                                                    className="btn btn-sm btn-success" 
                                                                    onClick={() => abrirModalAtualizarSenha(usu)}
                                                                    disabled={loading}
                                                                >
                                                                    Alterar Senha
                                                                </button>
                                                                <button 
                                                                    className="btn btn-sm btn-info" 
                                                                    onClick={() => abrirModalFeiras(usu)}
                                                                    disabled={loading}
                                                                >
                                                                    Editar Feiras
                                                                </button>
                                                                <button 
                                                                    className="btn btn-sm btn-danger" 
                                                                    onClick={() => deletarUsuario(usu.id)}
                                                                    disabled={loading}
                                                                >
                                                                    Desativar
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Modal isOpen={modal_list} toggle={tog_list} centered onClosed={() => {
                        setselectedMulti(null);
                        setselectedTipo(null);
                    }}>
                        <ModalHeader className="bg-light p-3" toggle={loading ? undefined : tog_list}>
                            Adicionar usuário
                        </ModalHeader>
                        <ModalBody>
                            <Form id="form-adicionar-usuario" onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Label>Nome *</Label>
                                            <Input
                                                name="first_name"
                                                type="text"
                                                placeholder="Informe o nome"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.first_name || ""}
                                                invalid={validation.touched.first_name && validation.errors.first_name ? true : false}
                                                disabled={loading}
                                            />
                                            {validation.touched.first_name && validation.errors.first_name ? (
                                                <FormFeedback>{validation.errors.first_name}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Label>E-mail *</Label>
                                            <Input
                                                name="email"
                                                type="email"
                                                placeholder="Informe o e-mail"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.email || ""}
                                                invalid={validation.touched.email && validation.errors.email ? true : false}
                                                disabled={loading}
                                            />
                                            {validation.touched.email && validation.errors.email ? (
                                                <FormFeedback>{validation.errors.email}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <Label>Feiras</Label>
                                        <Select
                                            value={selectedMulti}
                                            isMulti={true}
                                            onChange={handleMulti}
                                            options={feirasOptions}
                                            placeholder={"Selecione ..."}
                                            styles={customStyles}
                                            isDisabled={loading}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Label>Tipo de usuário</Label>
                                        <Select
                                            value={selectedTipo}
                                            isMulti={false}
                                            onChange={handleTipo}
                                            options={tiposOptions}
                                            placeholder={"Selecione ..."}
                                            styles={customStyles}
                                            isDisabled={loading}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                        <ModalFooter>
                            <div className="hstack gap-2 justify-content-end">
                                <button 
                                    type="button" 
                                    className="btn btn-light" 
                                    onClick={tog_list}
                                    disabled={loading}
                                >
                                    Fechar
                                </button>
                                <button 
                                    type="submit" 
                                    form="form-adicionar-usuario" 
                                    className="btn btn-success"
                                    disabled={loading}
                                >
                                    {loading ? 'Salvando...' : 'Salvar'}
                                </button>
                            </div>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={modalFeiras} toggle={!loading ? fecharModalFeiras : undefined} centered onClosed={() => {
                        setUsuarioSelecionado(null);
                        setFeirasSelecionadas([]);
                    }}>
                        <ModalHeader toggle={!loading ? fecharModalFeiras : undefined}>
                            Editar Feiras do Usuário
                        </ModalHeader>
                        <ModalBody>
                            <Select
                                value={feirasSelecionadas}
                                isMulti={true}
                                onChange={setFeirasSelecionadas}
                                options={feirasOptions}
                                placeholder="Selecione as feiras"
                                styles={customStyles}
                                isDisabled={loading}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={fecharModalFeiras} disabled={loading}>
                                Cancelar
                            </Button>
                            <Button color="primary" onClick={salvarFeiras} disabled={loading}>
                                {loading ? 'Salvando...' : 'Salvar'}
                            </Button>
                        </ModalFooter>
                    </Modal>

                    <ModalAlterarSenha
                        isOpen={modalAtualizarSenha}
                        onClose={fecharModalAtualizarSenha}
                        onSave={async (id, senha) => {
                            try {
                            setLoading(true);
                            const body = {
                                usuario_id: id,
                                novaSenha: senha
                            };
                           
                            const response = await fetchComAuth(`${api.API_URL}/alterarSenha`, {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type': 'application/json', 
                                    'Accept': 'application/json'
                                },
                            });

                            if (!response.ok) throw new Error(await response.text());

                            toast.success("Senha atualizada com sucesso.");
                            setModalAtualizarSenha(false);

                            const refresh = await fetchComAuth(`${api.API_URL}/usuarios`, { method: 'GET'});
                            const dataRefresh = await refresh.json();
                            setUsuariosData(dataRefresh.data);
                            } catch (error) {
                            toast.error("Erro ao atualizar senha.");
                            console.error("Erro ao atualizar senha:", error);
                            } finally {
                            setLoading(false);
                            }
                        }}
                        usuario={usuarioSelecionado}
                        loading={loading}
                        />

                </Container>
            </div>
        </React.Fragment>
        
    );
   
};

export default ListaUsuarios;